import React from 'react';
import { useTranslation } from 'react-i18next';

function Partnerships() {
  const { t } = useTranslation();
  const whatsappPartnerUrl = `https://wa.me/221785949274?text=${encodeURIComponent(t('whatsapp.quoteMessage'))}`;

  return (
    <section className="partnerships-section" id="partnerships">
      <h3>{t('partnerships.title')}</h3>
      <p className="services-intro">{t('partnerships.description')}</p>
      <div className="hero-cta partnerships-cta">
        <a
          className="cta-button whatsapp"
          href={whatsappPartnerUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('partnerships.cta.whatsapp')}
        </a>
        <a
          className="cta-button secondary"
          href="https://www.linkedin.com/in/cheikh-ngom-a58ba41b7"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('partnerships.cta.linkedin')}
        </a>
        <a className="cta-button download" href="/onepager-baobabsquare-fr.pdf" download>
          {t('partnerships.cta.onepager_fr')}
        </a>
        <a className="cta-button download" href="/onepager-baobabsquare-en.pdf" download>
          {t('partnerships.cta.onepager_en')}
        </a>
      </div>
    </section>
  );
}

export default Partnerships;
